import { StockCount as StockCountComponent } from 'b2b-components/theme/components/StockCount';
import { withContainer } from './withContainer';

const StockCount = withContainer(StockCountComponent);

export { StockCount, StockCountComponent };
export * from './withContainer';
